// Base URL de la API desde las variables de entorno
const API_BASE = import.meta.env.VITE_API_URL

// Crear un nuevo funcionario (solo para pruebas)
export async function crearFuncionario() {
  try {
    const bodyData = {
      email: "benja@gmail.com",
      password: "12345",
      nombre: "benja",
      meson: "Meson 1",
      cargo: "jefatura",
    };

    const response = await fetch(`${API_BASE}/accounts/funcionarios/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(bodyData),
      credentials: 'include',
    });

    if (!response.ok) {
      const text = await response.text().catch(() => "<no body>");
      console.error("crearFuncionario: respuesta no OK", response.status, text);
      throw new Error("Error creando funcionario");
    }

    const contentType = (response.headers.get("content-type") || "").toLowerCase();
    if (!contentType.includes("application/json")) {
      const text = await response.text().catch(() => "<no body>");
      console.error("crearFuncionario: se esperaba JSON pero el servidor devolvió:", text);
      throw new Error("Respuesta no JSON del servidor");
    }

    const data = await response.json();
    console.log("Funcionario creado:", data);
    return data;
  } catch (err) {
    console.error("Error en crearFuncionario:", err);
    throw err;
  }
}

/**
 * PUT: Actualiza los datos de un mesón (libre, para jefatura)
 */
export async function actualizarMeson(mesonId, datos) {
  try {
    const response = await fetch(`${API_BASE}/service/meson/${mesonId}/`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(datos),
      credentials: 'include',
    });

    if (!response.ok) {
      const text = await response.text().catch(() => "<no body>");
      console.error("actualizarMeson: respuesta no OK", response.status, text);
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    const contentType = (response.headers.get("content-type") || "").toLowerCase();
    if (!contentType.includes("application/json")) {
      const text = await response.text().catch(() => "<no body>");
      console.error("actualizarMeson: se esperaba JSON pero el servidor devolvió:", text);
      throw new Error("Respuesta no JSON del servidor");
    }

    return await response.json();
  } catch (error) {
    console.error("Error en obtenerEstadisticasResumen:", error);
    throw error;
  }
}


/**
 * POST: crea un nuevo mesón
 * Endpoint: /service/meson/
 */
export async function crearMeson(campos) {
  try {
    const response = await fetch(`${API_BASE}/service/meson/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(campos),
      credentials: 'include',
    });

    if (!response.ok) {
      const text = await response.text().catch(() => "<no body>");
      console.error("crearMeson: respuesta no OK", response.status, text);
      throw new Error(
        `Error al crear mesón: ${response.status} ${response.statusText}`
      );
    }

    const contentType = (response.headers.get("content-type") || "").toLowerCase();
    if (!contentType.includes("application/json")) {
      const text = await response.text().catch(() => "<no body>");
      console.error("crearMeson: se esperaba JSON pero el servidor devolvió:", text);
      throw new Error("Respuesta no JSON del servidor");
    }

    return await response.json();
  } catch (err) {
    console.error("Error en crearMeson:", err);
    throw err;
  }
}

export async function eliminarMeson(idMeson) {
  try {
    const response = await fetch(`${API_BASE}/service/meson/${idMeson}/`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: 'include',
    });

    if (!response.ok) {
      const text = await response.text().catch(() => "<no body>");
      console.error("eliminarMeson: respuesta no OK", response.status, text);
      throw new Error(`Error eliminando mesón con ID ${idMeson}`);
    }

    console.log(`Mesón ${idMeson} eliminado correctamente`);
    return true; // O podrías retornar response.status === 204, si la API lo usa
  } catch (err) {
    console.error("Error en eliminarMeson:", err);
    throw err;
  }
}

/**
 * PUT: Actualiza los datos de un funcionario (libre, para jefatura)
 */
export async function actualizarFuncionario(funcionarioId, datos) {
    try {
        const response = await fetch(`${API_BASE}/accounts/funcionarios/${funcionarioId}/`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(datos),
          credentials: 'include',
        });
    
    if (!response.ok) {
      const text = await response.text().catch(() => "<no body>");
      console.error("actualizarFuncionario: respuesta no OK", response.status, text);
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    const contentType = (response.headers.get("content-type") || "").toLowerCase();
    if (!contentType.includes("application/json")) {
      const text = await response.text().catch(() => "<no body>");
      console.error("actualizarFuncionario: se esperaba JSON pero el servidor devolvió:", text);
      throw new Error("Respuesta no JSON del servidor");
    }

    return await response.json();
    } catch (error) {
        console.error("Error en actualizarFuncionario:", error);
        throw error;
        }
}

/**
 * POST: Crea un nuevo motivo
 * Endpoint: /service/motivo/
 * @param {string} nombre - Nombre del motivo a crear
 * @returns {Promise} - Datos del motivo creado
 */
export async function crearMotivo(nombre) {
  try {
    const response = await fetch(`${API_BASE}/service/motivo/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ nombre }),
      credentials: 'include',
    });

    if (!response.ok) {
      const text = await response.text().catch(() => "<no body>");
      console.error("crearMotivo: respuesta no OK", response.status, text);
      throw new Error(
        `Error al crear motivo: ${response.status} ${response.statusText}`
      );
    }

    const contentType = (response.headers.get("content-type") || "").toLowerCase();
    if (!contentType.includes("application/json")) {
      const text = await response.text().catch(() => "<no body>");
      console.error("crearMotivo: se esperaba JSON pero el servidor devolvió:", text);
      throw new Error("Respuesta no JSON del servidor");
    }

    const data = await response.json();
    console.log("Motivo creado:", data);
    return data;
  } catch (err) {
    console.error("Error en crearMotivo:", err);
    throw err;
  }
}

/**
 * PUT: Actualiza los datos de un motivo (nombre y/o estado activo)
 * Endpoint: /service/motivo/<pk>/
 * @param {number} motivoId - ID del motivo a actualizar
 * @param {object} datos - Campos a actualizar (nombre, activo)
 * @returns {Promise} - Respuesta del servidor
 */
export async function actualizarMotivo(motivoId, datos) {
  try {
    const response = await fetch(`${API_BASE}/service/motivo/${motivoId}/`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(datos),
      credentials: 'include',
    });

    if (!response.ok) {
      const text = await response.text().catch(() => "<no body>");
      console.error("actualizarMotivo: respuesta no OK", response.status, text);
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    const contentType = (response.headers.get("content-type") || "").toLowerCase();
    if (!contentType.includes("application/json")) {
      const text = await response.text().catch(() => "<no body>");
      console.error("actualizarMotivo: se esperaba JSON pero el servidor devolvió:", text);
      throw new Error("Respuesta no JSON del servidor");
    }

    const data = await response.json();
    console.log("Motivo actualizado:", data);
    return data;
  } catch (error) {
    console.error("Error en actualizarMotivo:", error);
    throw error;
  }
}


/**
 * GET: Obtiene las estadísticas del resumen para el dashboard
 * @param {Object} params - Parámetros de filtro
 * @param {string} params.period - Período predefinido (last_week, last_month, etc.)
 * @param {string} params.startDate - Fecha de inicio (formato YYYY-MM-DD) para período personalizado
 * @param {string} params.endDate - Fecha de fin (formato YYYY-MM-DD) para período personalizado
 * @returns {Promise<Object>} - Objeto con las estadísticas
 */
export async function obtenerEstadisticasResumen(params = {}) {
  try {
    // Construir query params
    const queryParams = new URLSearchParams();
    
    if (params.period && params.period !== 'custom') {
      queryParams.append('period', params.period);
    }
    
    if (params.startDate && params.endDate) {
      queryParams.append('start_date', params.startDate);
      queryParams.append('end_date', params.endDate);
    }

    const url = `${API_BASE}/feedback/estadisticas/resumen/?${queryParams.toString()}`;
    
    const response = await fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      credentials: 'include',
    });

    if (!response.ok) {
      const text = await response.text().catch(() => "<no body>");
      console.error("obtenerEstadisticasResumen: respuesta no OK", response.status, text);
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    const contentType = (response.headers.get("content-type") || "").toLowerCase();
    if (!contentType.includes("application/json")) {
      const text = await response.text().catch(() => "<no body>");
      console.error("obtenerEstadisticasResumen: se esperaba JSON pero el servidor devolvió:", text);
      throw new Error("Respuesta no JSON del servidor");
    }

    return await response.json();
  } catch (error) {
    console.error("Error en obtenerEstadisticasResumen:", error);
    throw error;
  }
}


/**
 * GET: Obtiene los datos de evolución temporal de atenciones por motivo
 * @param {Object} params - Parámetros de filtro
 * @param {string} params.period - Período predefinido (last_week, last_month, etc.)
 * @param {string} params.startDate - Fecha de inicio (formato YYYY-MM-DD) para período personalizado
 * @param {string} params.endDate - Fecha de fin (formato YYYY-MM-DD) para período personalizado
 * @returns {Promise<Object>} - Objeto con labels y datasets para el gráfico
 */
export async function obtenerEvolucionTemporal(params = {}) {
  try {
    // Construir query params
    const queryParams = new URLSearchParams();
    
    if (params.period && params.period !== 'custom') {
      queryParams.append('period', params.period);
    }
    
    if (params.startDate && params.endDate) {
      queryParams.append('start_date', params.startDate);
      queryParams.append('end_date', params.endDate);
    }

    const url = `${API_BASE}/feedback/evolucion-temporal/?${queryParams.toString()}`;
    
    const response = await fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      credentials: 'include',
    });

    if (!response.ok) {
      const text = await response.text().catch(() => "<no body>");
      console.error("obtenerEvolucionTemporal: respuesta no OK", response.status, text);
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    const contentType = (response.headers.get("content-type") || "").toLowerCase();
    if (!contentType.includes("application/json")) {
      const text = await response.text().catch(() => "<no body>");
      console.error("obtenerEvolucionTemporal: se esperaba JSON pero el servidor devolvió:", text);
      throw new Error("Respuesta no JSON del servidor");
    }

    return await response.json();
  } catch (error) {
    console.error("Error en obtenerEvolucionTemporal:", error);
    throw error;
  }
}


/**
 * GET: Obtiene las atenciones agrupadas por carrera
 * @param {Object} params - Parámetros de filtro
 * @param {string} params.period - Período predefinido (last_week, last_month, etc.)
 * @param {string} params.startDate - Fecha de inicio (formato YYYY-MM-DD) para período personalizado
 * @param {string} params.endDate - Fecha de fin (formato YYYY-MM-DD) para período personalizado
 * @returns {Promise<Object>} - Objeto con labels (carreras) y data (número de atenciones)
 */
export async function obtenerAtencionesPorCarrera(params = {}) {
  try {
    // Construir query params
    const queryParams = new URLSearchParams();
    
    if (params.period && params.period !== 'custom') {
      queryParams.append('period', params.period);
    }
    
    if (params.startDate && params.endDate) {
      queryParams.append('start_date', params.startDate);
      queryParams.append('end_date', params.endDate);
    }

    const url = `${API_BASE}/feedback/atenciones-por-carrera/?${queryParams.toString()}`;
    
    const response = await fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      credentials: 'include',
    });

    if (!response.ok) {
      const text = await response.text().catch(() => "<no body>");
      console.error("obtenerAtencionesPorCarrera: respuesta no OK", response.status, text);
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    const contentType = (response.headers.get("content-type") || "").toLowerCase();
    if (!contentType.includes("application/json")) {
      const text = await response.text().catch(() => "<no body>");
      console.error("obtenerAtencionesPorCarrera: se esperaba JSON pero el servidor devolvió:", text);
      throw new Error("Respuesta no JSON del servidor");
    }

    return await response.json();
  } catch (error) {
    console.error("Error en obtenerAtencionesPorCarrera:", error);
    throw error;
  }
}


/**
 * GET: Obtiene las atenciones agrupadas por motivo
 * @param {Object} params - Parámetros de filtro
 * @param {string} params.period - Período predefinido (last_week, last_month, etc.)
 * @param {string} params.startDate - Fecha de inicio (formato YYYY-MM-DD) para período personalizado
 * @param {string} params.endDate - Fecha de fin (formato YYYY-MM-DD) para período personalizado
 * @returns {Promise<Object>} - Objeto con labels (motivos) y data (número de atenciones)
 */
export async function obtenerAtencionesPorMotivo(params = {}) {
  try {
    // Construir query params
    const queryParams = new URLSearchParams();
    
    if (params.period && params.period !== 'custom') {
      queryParams.append('period', params.period);
    }
    
    if (params.startDate && params.endDate) {
      queryParams.append('start_date', params.startDate);
      queryParams.append('end_date', params.endDate);
    }

    const url = `${API_BASE}/feedback/atenciones-por-motivo/?${queryParams.toString()}`;
    
    const response = await fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      credentials: 'include',
    });

    if (!response.ok) {
      const text = await response.text().catch(() => "<no body>");
      console.error("obtenerAtencionesPorMotivo: respuesta no OK", response.status, text);
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    const contentType = (response.headers.get("content-type") || "").toLowerCase();
    if (!contentType.includes("application/json")) {
      const text = await response.text().catch(() => "<no body>");
      console.error("obtenerAtencionesPorMotivo: se esperaba JSON pero el servidor devolvió:", text);
      throw new Error("Respuesta no JSON del servidor");
    }

    return await response.json();
  } catch (error) {
    console.error("Error en obtenerSatisfaccionPorRango:", error);
    throw error;
  }
}

/**
 * GET: Obtiene la evolución temporal de encuestas por calificación
 * Endpoint: /feedback/evolucion-encuestas/
 * @param {Object} params - Parámetros de filtro
 * @param {string} params.period - Período predefinido (last_week, last_month, etc.)
 * @param {string} params.startDate - Fecha inicio (YYYY-MM-DD)
 * @param {string} params.endDate - Fecha fin (YYYY-MM-DD)
 * @returns {Promise} - Objeto con labels (temporales) y datasets (por calificación 1-7)
 */
export async function obtenerEvolucionEncuestas(params = {}) {
  try {
    // Construir query params
    const queryParams = new URLSearchParams();
    
    if (params.period && params.period !== 'custom') {
      queryParams.append('period', params.period);
    }
    
    if (params.startDate && params.endDate) {
      queryParams.append('start_date', params.startDate);
      queryParams.append('end_date', params.endDate);
    }

    const url = `${API_BASE}/feedback/evolucion-encuestas/?${queryParams.toString()}`;
    
    const response = await fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      credentials: 'include',
    });

    if (!response.ok) {
      const text = await response.text().catch(() => "<no body>");
      console.error("obtenerEvolucionEncuestas: respuesta no OK", response.status, text);
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    const contentType = (response.headers.get("content-type") || "").toLowerCase();
    if (!contentType.includes("application/json")) {
      const text = await response.text().catch(() => "<no body>");
      console.error("obtenerEvolucionEncuestas: se esperaba JSON pero el servidor devolvió:", text);
      throw new Error("Respuesta no JSON del servidor");
    }

    return await response.json();
  } catch (error) {
    console.error("Error en obtenerEvolucionEncuestas:", error);
    throw error;
  }
}

/**
 * GET: Obtiene los últimos comentarios de encuestas
 * Endpoint: /feedback/ultimos-comentarios/
 * @param {Object} params - Parámetros de filtro
 * @param {string} params.period - Período predefinido (last_week, last_month, etc.)
 * @param {string} params.startDate - Fecha inicio (YYYY-MM-DD)
 * @param {string} params.endDate - Fecha fin (YYYY-MM-DD)
 * @param {number} params.limit - Número máximo de comentarios (default: 15)
 * @returns {Promise} - Objeto con array de comentarios
 */
export async function obtenerUltimosComentarios(params = {}) {
  try {
    // Construir query params
    const queryParams = new URLSearchParams();
    
    if (params.period && params.period !== 'custom') {
      queryParams.append('period', params.period);
    }
    
    if (params.startDate && params.endDate) {
      queryParams.append('start_date', params.startDate);
      queryParams.append('end_date', params.endDate);
    }

    if (params.limit) {
      queryParams.append('limit', params.limit);
    }

    const url = `${API_BASE}/feedback/ultimos-comentarios/?${queryParams.toString()}`;
    
    const response = await fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      credentials: 'include',
    });

    if (!response.ok) {
      const text = await response.text().catch(() => "<no body>");
      console.error("obtenerUltimosComentarios: respuesta no OK", response.status, text);
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    const contentType = (response.headers.get("content-type") || "").toLowerCase();
    if (!contentType.includes("application/json")) {
      const text = await response.text().catch(() => "<no body>");
      console.error("obtenerUltimosComentarios: se esperaba JSON pero el servidor devolvió:", text);
      throw new Error("Respuesta no JSON del servidor");
    }

    return await response.json();
  } catch (error) {
    console.error("Error en obtenerUltimosComentarios:", error);
    throw error;
  }
}


/**
 * GET: Obtiene los datos de evolución temporal de atenciones por funcionario
 * @param {Object} params - Parámetros de filtro
 * @param {string} params.period - Período predefinido (last_week, last_month, etc.)
 * @param {string} params.startDate - Fecha de inicio (formato YYYY-MM-DD) para período personalizado
 * @param {string} params.endDate - Fecha de fin (formato YYYY-MM-DD) para período personalizado
 * @returns {Promise<Object>} - Objeto con labels y datasets para el gráfico
 */
export async function obtenerEvolucionPorFuncionario(params = {}) {
  try {
    // Construir query params
    const queryParams = new URLSearchParams();
    
    if (params.period && params.period !== 'custom') {
      queryParams.append('period', params.period);
    }
    
    if (params.startDate && params.endDate) {
      queryParams.append('start_date', params.startDate);
      queryParams.append('end_date', params.endDate);
    }

    if (params.funcionarioIds) {
      queryParams.append('funcionarioIds', params.funcionarioIds);
    }

    const url = `${API_BASE}/feedback/evolucion-por-funcionario/?${queryParams.toString()}`;
    
    const response = await fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      credentials: 'include',
    });

    if (!response.ok) {
      const text = await response.text().catch(() => "<no body>");
      console.error("obtenerEvolucionPorFuncionario: respuesta no OK", response.status, text);
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    const contentType = (response.headers.get("content-type") || "").toLowerCase();
    if (!contentType.includes("application/json")) {
      const text = await response.text().catch(() => "<no body>");
      console.error("obtenerEvolucionPorFuncionario: se esperaba JSON pero el servidor devolvió:", text);
      throw new Error("Respuesta no JSON del servidor");
    }

    return await response.json();
  } catch (error) {
    console.error("Error en obtenerEvolucionPorFuncionario:", error);
    throw error;
  }
}


/**
 * GET: Obtiene las estadísticas de estudiantes
 * @param {Object} params - Parámetros de filtro
 * @param {string} params.period - Período predefinido (last_week, last_month, etc.)
 * @param {string} params.startDate - Fecha de inicio (formato YYYY-MM-DD) para período personalizado
 * @param {string} params.endDate - Fecha de fin (formato YYYY-MM-DD) para período personalizado
 * @returns {Promise<Object>} - Objeto con todas las estadísticas de estudiantes
 */
export async function obtenerEstadisticasEstudiantes(params = {}) {
  try {
    // Construir query params
    const queryParams = new URLSearchParams();
    
    if (params.period && params.period !== 'custom') {
      queryParams.append('period', params.period);
    }
    
    if (params.startDate && params.endDate) {
      queryParams.append('start_date', params.startDate);
      queryParams.append('end_date', params.endDate);
    }

    const url = `${API_BASE}/feedback/estudiantes/estadisticas/?${queryParams.toString()}`;
    
    const response = await fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      credentials: 'include',
    });

    if (!response.ok) {
      const text = await response.text().catch(() => "<no body>");
      console.error("obtenerEstadisticasEstudiantes: respuesta no OK", response.status, text);
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    const contentType = (response.headers.get("content-type") || "").toLowerCase();
    if (!contentType.includes("application/json")) {
      const text = await response.text().catch(() => "<no body>");
      console.error("obtenerEstadisticasEstudiantes: se esperaba JSON pero el servidor devolvió:", text);
      throw new Error("Respuesta no JSON del servidor");
    }

    return await response.json();
  } catch (error) {
    console.error("Error en obtenerEstadisticasEstudiantes:", error);
    throw error;
  }
}


/**
 * GET: Obtiene las estadísticas de tickets y atenciones
 * @param {Object} params - Parámetros de filtro
 * @param {string} params.period - Período predefinido (last_week, last_month, etc.)
 * @param {string} params.startDate - Fecha de inicio (formato YYYY-MM-DD) para período personalizado
 * @param {string} params.endDate - Fecha de fin (formato YYYY-MM-DD) para período personalizado
 * @returns {Promise<Object>} - Objeto con todas las estadísticas de tickets y atenciones
 */
export async function obtenerEstadisticasTickets(params = {}) {
  try {
    // Construir query params
    const queryParams = new URLSearchParams();
    
    if (params.period && params.period !== 'custom') {
      queryParams.append('period', params.period);
    }
    
    if (params.startDate && params.endDate) {
      queryParams.append('start_date', params.startDate);
      queryParams.append('end_date', params.endDate);
    }

    const url = `${API_BASE}/feedback/estadisticas/tickets-atenciones/?${queryParams.toString()}`;
    
    const response = await fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      credentials: 'include',
    });

    if (!response.ok) {
      const text = await response.text().catch(() => "<no body>");
      console.error("obtenerEstadisticasTickets: respuesta no OK", response.status, text);
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    const contentType = (response.headers.get("content-type") || "").toLowerCase();
    if (!contentType.includes("application/json")) {
      const text = await response.text().catch(() => "<no body>");
      console.error("obtenerEstadisticasTickets: se esperaba JSON pero el servidor devolvió:", text);
      throw new Error("Respuesta no JSON del servidor");
    }

    return await response.json();
  } catch (error) {
    console.error("Error en obtenerEstadisticasTickets:", error);
    throw error;
  }
}


/**
 * GET: Obtiene la duración promedio por tipo de atención
 * @param {Object} params - Parámetros de filtro
 * @param {string} params.period - Período predefinido (last_week, last_month, etc.)
 * @param {string} params.startDate - Fecha de inicio (formato YYYY-MM-DD) para período personalizado
 * @param {string} params.endDate - Fecha de fin (formato YYYY-MM-DD) para período personalizado
 * @returns {Promise<Object>} - Objeto con labels y data para el gráfico
 */
export async function obtenerDuracionPromedioPorTipo(params = {}) {
  try {
    // Construir query params
    const queryParams = new URLSearchParams();
    
    if (params.period && params.period !== 'custom') {
      queryParams.append('period', params.period);
    }
    
    if (params.startDate && params.endDate) {
      queryParams.append('start_date', params.startDate);
      queryParams.append('end_date', params.endDate);
    }

    const url = `${API_BASE}/feedback/duracion-promedio-por-tipo/?${queryParams.toString()}`;
    
    const response = await fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      credentials: 'include',
    });

    if (!response.ok) {
      const text = await response.text().catch(() => "<no body>");
      console.error("obtenerDuracionPromedioPorTipo: respuesta no OK", response.status, text);
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    const contentType = (response.headers.get("content-type") || "").toLowerCase();
    if (!contentType.includes("application/json")) {
      const text = await response.text().catch(() => "<no body>");
      console.error("obtenerDuracionPromedioPorTipo: se esperaba JSON pero el servidor devolvió:", text);
      throw new Error("Respuesta no JSON del servidor");
    }

    return await response.json();
  } catch (error) {
    console.error("Error en obtenerDuracionPromedioPorTipo:", error);
    throw error;
  }
}

/**
 * GET: Obtiene las últimas atenciones
 * Endpoint: /feedback/ultimas-atenciones/
 * @param {string} period - Período (last_week, last_month, etc.)
 * @param {string} startDate - Fecha inicio (YYYY-MM-DD)
 * @param {string} endDate - Fecha fin (YYYY-MM-DD)
 * @param {number} limit - Número máximo de atenciones a retornar
 * @returns {Promise} - Objeto con array de atenciones
 */
export async function obtenerUltimasAtenciones(period = null, startDate = null, endDate = null, limit = 50) {
  try {
    const params = new URLSearchParams();
    
    if (period) {
      params.append('period', period);
    } else if (startDate && endDate) {
      params.append('start_date', startDate);
      params.append('end_date', endDate);
    }
    
    if (limit) {
      params.append('limit', limit);
    }

    const response = await fetch(`${API_BASE}/feedback/ultimas-atenciones/?${params}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
    });

    if (!response.ok) {
      const text = await response.text().catch(() => "<no body>");
      console.error("obtenerUltimasAtenciones: respuesta no OK", response.status, text);
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    const contentType = (response.headers.get("content-type") || "").toLowerCase();
    if (!contentType.includes("application/json")) {
      const text = await response.text().catch(() => "<no body>");
      console.error("obtenerUltimasAtenciones: se esperaba JSON pero el servidor devolvió:", text);
      throw new Error("Respuesta no JSON del servidor");
    }

    return await response.json();
  } catch (error) {
    console.error("Error en obtenerUltimasAtenciones:", error);
    throw error;
  }
}

/**
 * GET: Obtiene las estadísticas de encuestas de satisfacción
 * Endpoint: /feedback/estadisticas/encuestas/
 * @param {Object} params - Parámetros de filtro
 * @param {string} params.period - Período predefinido (last_week, last_month, etc.)
 * @param {string} params.startDate - Fecha inicio (YYYY-MM-DD)
 * @param {string} params.endDate - Fecha fin (YYYY-MM-DD)
 * @returns {Promise} - Objeto con puntuacion_promedio, total_encuestas, total_comentarios
 */
export async function obtenerEstadisticasEncuestas(params = {}) {
  try {
    // Construir query params
    const queryParams = new URLSearchParams();
    
    if (params.period && params.period !== 'custom') {
      queryParams.append('period', params.period);
    }
    
    if (params.startDate && params.endDate) {
      queryParams.append('start_date', params.startDate);
      queryParams.append('end_date', params.endDate);
    }

    const url = `${API_BASE}/feedback/estadisticas/encuestas/?${queryParams.toString()}`;
    
    const response = await fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      credentials: 'include',
    });

    if (!response.ok) {
      const text = await response.text().catch(() => "<no body>");
      console.error("obtenerEstadisticasEncuestas: respuesta no OK", response.status, text);
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    const contentType = (response.headers.get("content-type") || "").toLowerCase();
    if (!contentType.includes("application/json")) {
      const text = await response.text().catch(() => "<no body>");
      console.error("obtenerEstadisticasEncuestas: se esperaba JSON pero el servidor devolvió:", text);
      throw new Error("Respuesta no JSON del servidor");
    }

    return await response.json();
  } catch (error) {
    console.error("Error en obtenerEstadisticasEncuestas:", error);
    throw error;
  }
}

/**
 * GET: Obtiene la distribución de calificaciones de las encuestas
 * Endpoint: /feedback/distribucion-calificaciones/
 * @param {Object} params - Parámetros de filtro
 * @param {string} params.period - Período predefinido (last_week, last_month, etc.)
 * @param {string} params.startDate - Fecha inicio (YYYY-MM-DD)
 * @param {string} params.endDate - Fecha fin (YYYY-MM-DD)
 * @returns {Promise} - Objeto con labels (1-7) y data (cantidades)
 */
export async function obtenerDistribucionCalificaciones(params = {}) {
  try {
    // Construir query params
    const queryParams = new URLSearchParams();
    
    if (params.period && params.period !== 'custom') {
      queryParams.append('period', params.period);
    }
    
    if (params.startDate && params.endDate) {
      queryParams.append('start_date', params.startDate);
      queryParams.append('end_date', params.endDate);
    }

    const url = `${API_BASE}/feedback/distribucion-calificaciones/?${queryParams.toString()}`;
    
    const response = await fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      credentials: 'include',
    });

    if (!response.ok) {
      const text = await response.text().catch(() => "<no body>");
      console.error("obtenerDistribucionCalificaciones: respuesta no OK", response.status, text);
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    const contentType = (response.headers.get("content-type") || "").toLowerCase();
    if (!contentType.includes("application/json")) {
      const text = await response.text().catch(() => "<no body>");
      console.error("obtenerDistribucionCalificaciones: se esperaba JSON pero el servidor devolvió:", text);
      throw new Error("Respuesta no JSON del servidor");
    }

    return await response.json();
  } catch (error) {
    console.error("Error en obtenerDistribucionCalificaciones:", error);
    throw error;
  }
}

/**
 * GET: Obtiene la distribución de encuestas por rangos de satisfacción
 * Transforma los datos de distribución de calificaciones en rangos para PieChart
 * Endpoint: /feedback/distribucion-calificaciones/
 * @param {Object} params - Parámetros de filtro
 * @param {string} params.period - Período predefinido (last_week, last_month, etc.)
 * @param {string} params.startDate - Fecha inicio (YYYY-MM-DD)
 * @param {string} params.endDate - Fecha fin (YYYY-MM-DD)
 * @returns {Promise} - Objeto con labels y data para PieChart con rangos:
 *                      Muy Bajo (1-2), Bajo (3-4), Medio (5), Alto (6-7)
 */
export async function obtenerSatisfaccionPorRango(params = {}) {
  try {
    // Obtener la distribución de calificaciones original
    const distribucion = await obtenerDistribucionCalificaciones(params);
    
    // Transformar los datos en rangos
    // distribucion.labels = ["1", "2", "3", "4", "5", "6", "7"]
    // distribucion.data = [count1, count2, count3, count4, count5, count6, count7]
    
    const data = distribucion.data || [0, 0, 0, 0, 0, 0, 0];
    
    // Calcular totales por rango
    const muyBajo = data[0] + data[1];  // 1 y 2 estrellas
    const bajo = data[2] + data[3];     // 3 y 4 estrellas
    const medio = data[4];              // 5 estrellas
    const alto = data[5] + data[6];     // 6 y 7 estrellas
    
    // Retornar en formato para PieChart
    return {
      labels: ["Muy Bajo (1-2)", "Bajo (3-4)", "Medio (5)", "Alto (6-7)"],
      data: [muyBajo, bajo, medio, alto]
    };
  } catch (error) {
    console.error("Error en obtenerSatisfaccionPorRango:", error);
    throw error;
  }
}

/**
 * Estadísticas de la nueva encuesta de satisfacción.
 * Acceso exclusivo para jefaturas, validado por el backend.
 */
export async function obtenerEstadisticasNuevaEncuesta(params = {}) {
  const queryParams = new URLSearchParams();

  if (params.fechaInicio) {
    queryParams.append("fecha_inicio", params.fechaInicio);
  }

  if (params.fechaFin) {
    queryParams.append("fecha_fin", params.fechaFin);
  }

  if (params.mesonId) {
    queryParams.append("meson_id", params.mesonId);
  }

  const url = `${API_BASE}/feedback/estadisticas/encuesta-satisfaccion/?${queryParams.toString()}`;

  const response = await fetch(url, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error(`Error ${response.status} al consultar las estadísticas`);
  }

  const contentType = response.headers.get("content-type") || "";

  if (!contentType.toLowerCase().includes("application/json")) {
    throw new Error("El servidor no devolvió una respuesta JSON");
  }

  return await response.json();
}


/**
 * Obtiene los comentarios de la nueva encuesta.
 * Acceso restringido a jefaturas desde el backend.
 */
export async function obtenerComentariosNuevaEncuesta(params = {}) {
  const queryParams = new URLSearchParams();

  if (params.fechaInicio) {
    queryParams.append("fecha_inicio", params.fechaInicio);
  }

  if (params.fechaFin) {
    queryParams.append("fecha_fin", params.fechaFin);
  }

  if (params.mesonId) {
    queryParams.append("meson_id", params.mesonId);
  }

  const url = `${API_BASE}/feedback/comentarios/encuesta-satisfaccion/?${queryParams.toString()}`;

  const response = await fetch(url, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error(`Error ${response.status} al consultar los comentarios`);
  }

  const contentType = response.headers.get("content-type") || "";

  if (!contentType.toLowerCase().includes("application/json")) {
    throw new Error("El servidor no devolvió una respuesta JSON");
  }

  return await response.json();
}

/**
 * Descarga todas las respuestas de la encuesta de satisfacción.
 * Respeta los filtros aplicados y requiere permisos de jefatura.
 */
export async function descargarExcelNuevaEncuesta(params = {}) {
  const queryParams = new URLSearchParams();

  if (params.fechaInicio) {
    queryParams.append("fecha_inicio", params.fechaInicio);
  }

  if (params.fechaFin) {
    queryParams.append("fecha_fin", params.fechaFin);
  }

  if (params.mesonId) {
    queryParams.append("meson_id", params.mesonId);
  }

  const url = `${API_BASE}/feedback/exportar/encuesta-satisfaccion/?${queryParams.toString()}`;

  const response = await fetch(url, {
    method: "GET",
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error(
      `No fue posible descargar el Excel (error ${response.status})`
    );
  }

  const contentType = response.headers.get("content-type") || "";

  if (!contentType.includes(
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  )) {
    throw new Error("El servidor no devolvió un archivo Excel válido");
  }

  const archivo = await response.blob();
  const enlace = document.createElement("a");
  const urlTemporal = URL.createObjectURL(archivo);

  try {
    enlace.href = urlTemporal;
    enlace.download = "encuesta_satisfaccion.xlsx";
    document.body.appendChild(enlace);
    enlace.click();
  } finally {
    enlace.remove();
    setTimeout(() => URL.revokeObjectURL(urlTemporal), 1000);
  }
}
/**
 * Consulta si el envío automático de encuestas está activado.
 */
export async function obtenerConfiguracionEnvioEncuestas() {
  const response = await fetch(
    `${API_BASE}/feedback/configuracion/envio-encuestas/`,
    {
      method: "GET",
      credentials: "include",
    }
  );

  if (!response.ok) {
    throw new Error(`Error ${response.status} al consultar la configuración`);
  }

  return await response.json();
}

/**
 * Activa o desactiva el envío automático.
 * Solo las jefaturas autorizadas pueden modificarlo.
 */
export async function actualizarConfiguracionEnvioEncuestas(activar) {
  const cookie = document.cookie
    .split("; ")
    .find((item) => item.startsWith("turnomatico_csrftoken="));

  const csrfToken = cookie
    ? decodeURIComponent(cookie.split("=").slice(1).join("="))
    : "";

  if (!csrfToken) {
    throw new Error("No se encontró el token de seguridad CSRF");
  }

  const response = await fetch(
    `${API_BASE}/feedback/configuracion/envio-encuestas/`,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": csrfToken,
      },
      body: JSON.stringify({
        envio_automatico: activar,
      }),
    }
  );

  if (!response.ok) {
    throw new Error(`Error ${response.status} al actualizar la configuración`);
  }

  return await response.json();
}